const Plus = () => {
  return (
    <svg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8 4v8m4-4H4' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export default Plus;
